import { TextFieldProps } from '@cash-me/react-components'

import { formatCNPJNumber, formatCPFNumber } from 'utils/formatter'

import { formatCep } from './formatCep'
import { formatDate } from './formatDate'
import { formatPhone } from './formatPhone'

type MaskType = NonNullable<TextFieldProps['mask']>

// Workaround para bug de máscara no onChange do @cash-me/react-components — remover ao
// atualizar para >= 6.0.0. Contexto: ./README.md, CPT-1778.
export const applyMask = (rawValue: string, mask: MaskType): string => {
  switch (mask) {
    case 'phone':
      return formatPhone(rawValue)
    case 'cpf':
      return formatCPFNumber(rawValue)
    case 'cnpj':
      return formatCNPJNumber(rawValue)
    case 'date':
      return formatDate(rawValue)
    case 'cep':
      return formatCep(rawValue)
    default:
      return rawValue
  }
}
